<template>
    <div class="task_row" @click="cellClick">
        <img :src="task.icon" alt="" class="task_icon" />
        <div class="task_title">
            {{ task.title }}
            <img :src="iconScore" alt="" class="task_score_icon" />
            <span class="task_score_plus_symbol">+{{ task.afterRewardScore }}</span>
            <div class="tj-mark" v-if="task.taskType === 'recommendTask'">推荐任务</div>
        </div>
        <div class="task_desc">{{ task.desc }}</div>
        <div class="task_status" v-if="task.taskStatus === 3 || task.taskStatus === 2">
            {{ task.taskButtonText }}
        </div>
        <div class="task_desc_btn" v-else>{{ task.taskButtonText }}</div>
    </div>
</template>

<script>
import iconScore from '@/assets/img/icon-score.png';
export default {
    name: 'TaskRow',
    props: {
        task: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            iconScore
        };
    },
    methods: {
        cellClick() {
            this.$emit('Oncellclick', this.task);
        }
    }
};
</script>

<style lang="less" scoped>
.task_row {
    height: 38px;
    widows: 375px;
    overflow: hidden;
    position: relative;

    .task_icon {
        width: 30px;
        height: 30px;
        position: absolute;
        left: 18px;
        top: 4px;
    }

    .task_title {
        height: 17px;
        font-size: 14px;
        font-weight: bold;
        color: #002a3c;
        line-height: 17px;
        position: absolute;
        left: 58px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .task_score_icon {
            width: 16px;
            height: 16px;
            margin-left: 4px;
        }

        .task_score_plus_symbol {
            height: 14px;
            font-size: 12px;
            font-family: 'fzlt_bold';
            font-weight: normal;
            color: #ff5a5a;
            line-height: 14px;
            margin-left: 2px;
        }
        .tj-mark {
            margin-left: 4px;
            padding: 0 4px;
            height: 14px;
            background: linear-gradient(90deg, #faebaa 0%, #f3c661 100%);
            border-radius: 2px;
            opacity: 0.67;
            color: #904e30;
            font-size: 10px;
            line-height: 14px;
            font-weight: bold;
            text-align: center;
        }
    }

    .task_desc {
        height: 14px;
        font-size: 12px;
        font-weight: bold;
        color: #9faab5;
        line-height: 14px;
        position: absolute;
        left: 58px;
        top: 24px;
    }
    .task_desc_btn {
        width: 70px;
        height: 28px;
        top: 5px;
        background: linear-gradient(90deg, #f4d583 0%, #f0bc53 100%);
        border-radius: 15px;
        position: absolute;
        right: 18px;
        line-height: 29px;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        color: #904e30;
    }

    .task_status {
        width: 60px;
        height: 14px;
        font-size: 12px;
        font-weight: bold;
        color: #9faab5;
        line-height: 14px;
        position: absolute;
        top: 12px;
        right: 23px;
        white-space: nowrap;
        text-align: center;
    }
}
</style>